<template>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24"
    aria-hidden="true" 
    stroke="currentColor" 
    stroke-width="2" 
    troke-linecap="round" 
    stroke-linejoin="round" 
    class="Notivue__close-icon"
  >
    <line
      x1="18"
      y1="6"
      x2="6"
      y2="18"
    />
    <line
      x1="6"
      y1="6"
      x2="18"
      y2="18"
    />
  </svg>
</template>